import { render } from "./Spaceship.vue?vue&type=template&id=214a02a7"
import script from "./Spaceship.vue?vue&type=script&lang=js"
export * from "./Spaceship.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__